import { render, staticRenderFns } from "./console-drawer.vue?vue&type=template&id=67724a63&"
import script from "./console-drawer.vue?vue&type=script&lang=js&"
export * from "./console-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports